import React, { useState } from "react";
import "./statstab.scss";
import Statsdetails from "../statsdetails";
import Chathistory from "../chathistory";
import Knowledgesources from "../knowledgesources";
import Chatbotsettings from "../chatbotsettings";
import Embeddingscript from "../embeddingscript";
import { useParams } from "react-router-dom";
import AnimatedSection from "../../../common/animatedsection";
import Createknowledgesource from "../../../components/modal/createknowledgesource";
import { deleteFile, getUploadedFile } from "../../../store/slices/embeddingSlice";
import { getAllProject } from "../../../store/slices/projectSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Conformation from "../../../components/modal/conformation";
import DeleteIcon from "../../../assets/icons/delete-icons.svg"
import toast from "react-hot-toast";

export default function Statstab() {
  const { route } = useParams();
  const { selectedProject, project } = useSelector((state) => state.project);
  const [createknowledgesource, setCreateknowledgesource] = useState(false);
  const [deleteKnowledgeSource, setDeleteKnowledgeSource] = useState(false);
  const [deletedData, setDeletedData] = useState({})
  const dispatch = useDispatch();

  useEffect(() => {
    if (!project || project.length === 0) {
      dispatch(getAllProject({}));
    }
  }, [dispatch, project]);

  const getAllUploadFile = () => {
    let body = {
      offset: 0,
      project_id: selectedProject?.id,
    };
    dispatch(getUploadedFile(body));
  };

  const handleDeleteFile = (data) => {
    let body = {
      id: data?.id,
    };
    dispatch(deleteFile(body))
      .unwrap()
      .then((res) => {
        if (!res?.data?.success) {
          toast.error(res?.data?.message);
          return;
        }
        toast.success(res?.data?.message);
        setDeleteKnowledgeSource(false)
      });
  };

  const getPageTitle = () => {
    switch (route) {
      case 'chat-history': return 'Chat History';
      case 'knowledge-sources': return 'Knowledge Sources';
      case 'chatbot-settings':
      case 'settings': return 'Chatbot Settings';
      case 'enbedding-script':
      case 'integration': return 'Integration';
      default: return 'Overview';
    }
  };

  return (
    <>
      <div className="container">
        <div className="page-header">
          <h3>{getPageTitle()}</h3>
        </div>

        <div className="tab-all-information-content-alignment">
          {(route === "stats" || route === undefined) && (
            <AnimatedSection animationType="fade-up" duration={500} delay={100}>
              <Statsdetails />
            </AnimatedSection>
          )}
          {route === "chat-history" && (
            <AnimatedSection animationType="fade-up" duration={500} delay={100}>
              <Chathistory />
            </AnimatedSection>
          )}
          {route === "knowledge-sources" && (
            <AnimatedSection animationType="fade-up" duration={500} delay={100}>
              <Knowledgesources
                createknowledgesource={createknowledgesource}
                setCreateknowledgesource={setCreateknowledgesource}
                deleteKnowledgeSource={deleteKnowledgeSource}
                setDeleteKnowledgeSource={setDeleteKnowledgeSource}
                deletedData={deletedData} setDeletedData={setDeletedData}
              />
            </AnimatedSection>
          )}
          {(route === "chatbot-settings" || route === "settings") && (
            <AnimatedSection animationType="fade-up" duration={500} delay={100}>
              <Chatbotsettings />
            </AnimatedSection>
          )}
          {route === "enbedding-script" && (
            <AnimatedSection animationType="fade-up" duration={500} delay={100}>
              <Embeddingscript />
            </AnimatedSection>
          )}
          {route === "integration" && (
            <AnimatedSection animationType="fade-up" duration={500} delay={100}>
              <Embeddingscript />
            </AnimatedSection>
          )}
        </div>
      </div>
      <Createknowledgesource
        createknowledgesource={createknowledgesource}
        setCreateknowledgesource={setCreateknowledgesource}
        getAllUploadFile={getAllUploadFile}
      />
      <Conformation isModal={deleteKnowledgeSource}
        title={"Delete"}
        onClose={() => setDeleteKnowledgeSource(!deleteKnowledgeSource)}
        onClick={() => handleDeleteFile(deletedData)}
        message={`Are you sure, you want to delete ${deletedData?.input_file_name} project?`}
        btnText={"Delete"}
        icon={DeleteIcon}

      />
    </>
  );
}
